<!-- =========================================================================================
  File Name: UserList.vue
  Description: Integration Users List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <!-- v-if="Object.keys(action) > 0"  -->
    <module-actions-form action="edit" :data="action" />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { setApplicationLocalStorageItem, performFetch } from '../../helpers'
import ModuleActionsForm from './ModuleActionsForm.vue'

export default {
  components: {
    vSelect,
    ModuleActionsForm
  },
  data: () => ({
    action: {}
  }),
  watch: {
    selectedRows(value) {
      // console.log(value)
    },

  },
  methods: {
    async getData() {

      this.$vs.loading({ type: 'default' })

      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_action__get_by_hash',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          action_hash: this.$route.params.actionHash
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              this.action = response.action;

              this.$vs.loading.close();

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToRefresh = ''

    }
  },
  async mounted() {
    await this.getData();
  }
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
